import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Typography, 
  Button, 
  Paper,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import { 
  Subscription, 
  Warning, 
  CheckCircle,
  Email,
  Lock,
  Phone,
  Message
} from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      width: '100%',
      height: '70%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  title: {
    backgroundColor: '#F97B18',
    color: 'white',
    padding: theme.spacing(2),
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '18px',
  },
  content: {
    padding: theme.spacing(2),
    backgroundColor: '#fafafa',
    flex: 1,
    overflow: 'auto',
  },
  greeting: {
    marginBottom: theme.spacing(1.5),
    fontSize: '15px',
    fontWeight: '500',
  },
  paragraph: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    fontSize: '14px',
    lineHeight: 1.4,
  },
  actionsTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#F97B18',
  },
  list: {
    marginTop: theme.spacing(0.2),
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: theme.spacing(0.2),
    paddingBottom: theme.spacing(0.2),
  },
  listItemText: {
    fontSize: '13px',
    lineHeight: 1.3,
  },
  warningBox: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '8px',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  warningText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#856404',
  },
  infoBox: {
    backgroundColor: '#d1ecf1',
    border: '1px solid #bee5eb',
    borderRadius: '8px',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
  },
  infoText: {
    fontSize: '13px',
    color: '#0c5460',
  },
  signature: {
    marginTop: theme.spacing(2),
    textAlign: 'right',
    fontSize: '13px',
    fontStyle: 'italic',
  },
  actions: {
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    borderTop: '1px solid #e0e0e0',
    flexShrink: 0,
  },
  confirmButton: {
    backgroundColor: '#F97B18',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: '#e06a0f',
    },
  },
}))

function SubscribersNotification({ onClose }) {
  const classes = useStyles()
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Verifica se já foi mostrado antes
    const hasSeenSubscriptionNotification = false//localStorage.getItem('subscriptionNotificationSeen')
    
    if (!hasSeenSubscriptionNotification) {
      // Mostra após um pequeno delay para dar tempo da página carregar
      const timer = setTimeout(() => {
        setShow(true)
      }, 2000)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleClose = () => {
    setShow(false)
    // Marca como visto no localStorage
    localStorage.setItem('subscriptionNotificationSeen', 'true')
    if (onClose) onClose()
  }

  if (!show) return null

  return (
    <Dialog 
      open={show} 
      onClose={handleClose}
      className={classes.dialog}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle className={classes.title}>
        <Message style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        Comunicado Importante – Envio de Links por WhatsApp
      </DialogTitle>
      
      <DialogContent className={classes.content}>
        <Typography className={classes.greeting}>
          Prezados franqueados,
        </Typography>
        
        <Typography className={classes.paragraph}>
          A partir de agora, os links de:
        </Typography>

        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <ListItemIcon>
              <CheckCircle style={{ color: '#F97B18', fontSize: '16px' }} />
            </ListItemIcon>
            <ListItemText 
              className={classes.listItemText}
              primary="❌ Cancelamento"
            />
          </ListItem>
          
          <ListItem className={classes.listItem}>
            <ListItemIcon>
              <CheckCircle style={{ color: '#F97B18', fontSize: '16px' }} />
            </ListItemIcon>
            <ListItemText 
              className={classes.listItemText}
              primary="💳 Troca de cartão"
            />
          </ListItem>
          
          <ListItem className={classes.listItem}>
            <ListItemIcon>
              <CheckCircle style={{ color: '#F97B18', fontSize: '16px' }} />
            </ListItemIcon>
            <ListItemText 
              className={classes.listItemText}
              primary="🔄 Troca de plano"
            />
          </ListItem>
        </List>

        <Typography className={classes.paragraph}>
          Serão enviados pelo WhatsApp de suporte da Petland.
        </Typography>

        <Typography className={classes.paragraph}>
          Quando a loja clicar para enviar o link, ele será disparado automaticamente pelo número de suporte e por e-mail para o cliente.
        </Typography>

        <Box className={classes.infoBox}>
          <Typography className={classes.infoText} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Phone style={{ fontSize: '18px' }} />
            <strong>📲 Número oficial do suporte: (11) 97262-6101</strong>
          </Typography>
        </Box>

        <Typography className={classes.paragraph}>
          É o mesmo número que vocês relatavam problemas da agenda, agora ele é exclusivo para mandar os links para os clientes.
        </Typography>

        <Typography className={classes.signature}>
          Atenciosamente,<br />
          Equipe Petland.
        </Typography>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button 
          onClick={handleClose}
          className={classes.confirmButton}
          variant="contained"
          size="large"
        >
          Entendi e Li o Comunicado
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SubscribersNotification
